import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=046e8b2c"
import script from "./orders-list.vue?vue&type=script&lang=ts"
export * from "./orders-list.vue?vue&type=script&lang=ts"
import style0 from "./orders-list.vue?vue&type=style&index=0&id=046e8b2c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046e8b2c')) {
      api.createRecord('046e8b2c', component.options)
    } else {
      api.reload('046e8b2c', component.options)
    }
    module.hot.accept("./orders-list.vue?vue&type=template&id=046e8b2c", function () {
      api.rerender('046e8b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/orders-list.vue"
export default component.exports